/**
 * Single horizontal container for page sections — keeps the same padding as
 * the global Navbar (`px-4 sm:px-16` + `.container mx-auto`) so section
 * content lines up with the header. Change side paddings here, once.
 */
export default function Container({ className = "", children }) {
  return (
    <div className={`px-4 sm:px-16 ${className}`}>
      <div className="container mx-auto">{children}</div>
    </div>
  );
}
